import * as request from '@/utils/request'
const BASE_URL = '/v1/manage/sale'
export default {
	getShareRecordList(data) {
		return request.get(`${BASE_URL}`, data)
	},
	getShareRegisterList(data) {
		return request.get(`${BASE_URL}/export`, data)
	},
	addShareSales(data) {
		return request.post(`${BASE_URL}/create`, data)
	},
	deleteSalesPerson(id){
		return request.Delete(`${BASE_URL}/delete/${id}`)
	}
}
